import "core-js/modules/es.array.concat.js";
import redirect from '../../utils/redirect';
import User from '../../user';
import Env from '../../env';
import UA from '../../ua';
import $ from 'zepto';
var cls = '#m-footer-tab';
var icon = '';
var imgUrl = '//s3plus.meituan.net/v1/mss_248f1907dfaa4c71934ce48dc98c107a/static/icon';
var css = "\n  ".concat(cls, " {\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    left: 0;\n    height: 50px;\n    display: flex;\n    background: #fafafa;\n    z-index: 999;\n    padding-top: 5px;\n  }\n  ").concat(cls, " .item {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n  ").concat(cls, " .text {\n    font-size: 12px;\n    transform: scale(0.85);\n    transform-origin: bottom center;\n  }\n  ").concat(cls, " .icon {\n    width: 18px;\n    height: 18px;\n  }\n  ").concat(cls, " .home .icon {\n    background: url('").concat(imgUrl, "/home.png') no-repeat center center / cover;\n  }\n  ").concat(cls, " .list .icon {\n    background: url('").concat(imgUrl, "/list.png') no-repeat center center / cover;\n  }\n  ").concat(cls, " .order .icon {\n    background: url('").concat(imgUrl, "/order.png') no-repeat center center / cover;\n  }\n  ").concat(cls, " .item.active .text {\n    color: #f03d37;\n  }\n  ").concat(cls, " .home.active .icon {\n    background: url('").concat(imgUrl, "/home-ac.png') no-repeat center center / cover;\n  }\n  ").concat(cls, " .list.active .icon {\n    background: url('").concat(imgUrl, "/list-ac.png') no-repeat center center / cover;\n  }\n  ").concat(cls, " .order.active .icon {\n    background: url('").concat(imgUrl, "/order-ac.png') no-repeat center center / cover;\n  }\n");
var footerMTab = function footerMTab() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'home';
  if ($(cls).length) return;
  var $body = $('body');
  $("<style>".concat(css, "</style>")).appendTo('head');
  var ICBC_PRAGMA = UA.IS_SHENZHEN_ICBC ? '?sellChannel=35' : '';
  $body.append("\n    <footer id=\"m-footer-tab\">\n      <div data-uri='/myshow/index.html?$$frombottomtab=1' class=\"item home ".concat(name === 'home' ? 'active' : '', "\" data-seed=\"name:bottomTab,bid:b_94xhc6iu\">\n        <div class=\"icon\"></div>\n        <div class=\"text\">\u9996\u9875</div>\n      </div>\n      <div data-uri='/myshow/").concat(ICBC_PRAGMA, "#/order-list?$$frombottomtab=1' class=\"item order ").concat(name === 'order' ? 'active' : '', "\" data-seed=\"name:bottomTab,bid:b_2ux167bs\">\n        <div class=\"icon\"></div>\n        <div class=\"text\">\u8BA2\u5355</div>\n      </div>\n    </footer>\n  "));
  $(cls).on('click', '[data-uri]:not(.active)', function (e) {
    var url = $(this).data('uri');
    // 前端不主动登录， 由后端接口code决定登录状态
    // if ( /\/order-list/.test( url ) ) {
    //   const redirUrl = redirect.getUrl( url )
    //   return User.login( { redirUrl } )
    // }
    redirect(url);
  });
};
footerMTab.show = function () {
  $(cls).css({
    'display': 'flex'
  });
  $('body').css({
    'padding-bottom': '50px'
  });
};
footerMTab.hide = function () {
  $(cls).css({
    display: 'none'
  });
  $('body').css({
    'paddingBottom': '0'
  });
};
export default footerMTab;